import type { SubAsset } from '@/common/sub-asset';
import { axios } from '@/lib/utils/axios';

import { getResponse } from '../common';
import { API_URLS } from '../query.client';

export type GetSubAssetSuccessResponseType = SubAsset;

export async function addSubAsset(subAssetPayload: Omit<SubAsset, 'id'>): Promise<GetSubAssetSuccessResponseType | null> {
	const response = await axios.post(`${API_URLS.SUB_ASSETS.INDEX}`, subAssetPayload);
	return getResponse<GetSubAssetSuccessResponseType>(response.data);
}
